import React from 'react';
import Loadable from 'react-loadable';
import otRoutes from './Modules/ot';
import customerRoutes from './Modules/customer';
import productRoutes from './Modules/product';

const Dashboard = Loadable({
    loader: () => import('../Components/Dashboard/SellerDashboard'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const routes = [
    ...otRoutes,
    ...customerRoutes,
    ...productRoutes,
    ...[
        { path: '/dashboard', name: 'Home', exact: true, component: Dashboard },
    ],
];

const menu = {
    items: [
        {
            name: 'Home',
            url: '/dashboard',
            icon: 'icon-layers',
        },
        {
            name: 'Calendario',
            url: '/ot/calendar',
            icon: 'icon-layers',
        },
        {
            name: 'Ordenes',
            url: '/ot/list',
            icon: 'icon-layers',
        },
        {
            name: 'Cotizaciones',
            url: '/quote/list',
            icon: 'icon-layers',
        },
        {
            name: 'Productos',
            url: '/product/list',
            icon: 'icon-layers',
        },
        {
            name: 'Clientes',
            url: '/customer/list',
            icon: 'icon-layers',
        },
    ],
};

export default {
    routes,
    menu,
};



// WEBPACK FOOTER //
// ./src/Routes/seller.js